'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var parseCreditcard = exports.parseCreditcard = function parseCreditcard(account) {
  // process default value of expiry year & month of creditcard, i.e., expiryDate = 2021-03
  var expiryDate = void 0;

  if (account.expiryDate) {
    var expiryYear = account.expiryDate.substring(2, 4);
    var expiryMonth = account.expiryDate.substring(5, 7);
    expiryDate = expiryMonth + '/' + expiryYear;
  }

  return {
    cardHolder: account.cardHolder,
    cardNumber: account.maskedAccount || account.cardNumber,
    expiryDate: expiryDate
  };
};

var parseEmail = exports.parseEmail = function parseEmail(account) {
  return {
    email: account.maskedAccount || ''
  };
};

var parseNeteller = exports.parseNeteller = function parseNeteller(account) {
  return {
    account: account.maskedAccount || account.account
  };
};

var parsePhoneNumber = exports.parsePhoneNumber = function parsePhoneNumber(account) {
  return {
    phoneNumber: account.phoneNumber || account.maskedAccount
  };
};

var parseVenusPoint = exports.parseVenusPoint = function parseVenusPoint(account) {
  return {
    account: account.maskedAccount || account.account
  };
};

var parseVega = exports.parseVega = function parseVega(account) {
  return {
    account: account.maskedAccount || account.account
  };
};

var parseMifinity = exports.parseMifinity = function parseMifinity(account) {
  return {
    account: account.maskedAccount || account.account
  };
};

var parseParamount = exports.parseParamount = function parseParamount(account) {
  return {
    securityQuestion: account.maskedAccount || account.account
  };
};